export default {
    // 获取菜单树
    getMenu: "/menu/getMenuTree",
    // 新增菜单
    getSaveMenu: "/menu/saveMenu",
    // 删除菜单
    getDelMenu: "/menu/delMenu",
    // 修改菜单
    getUpdateMenu: "/menu/updateMenu",
    // 根据roleID 获取菜单树
    getMenuTreeByRoleId: "/menu/getMenuTreeByRoleId",
    // 获取report List
    getReportList:"/menu/getSelectdReport",
    // 根据ID获取到menu 详情
    getMenuById:"/menu/getMenuById",
};
